import React from "react";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ContentShell from "components/ContentShell";
import BulkUploadPanel from "components/bulkUpload/BulkUploadPanel";
import configData from "config/config.json";
import {
  bulkCreateBanners,
  downloadBannerBulkTemplate,
  validateBannerBulkUpload,
} from "services/homeBannerService";

const BulkUploadBanners = () => {
  const navigate = useNavigate();

  return (
    <ContentShell title="Bulk Upload Banners">
      <Box sx={{ maxWidth: 980, mx: "auto", py: 1 }}>
        <BulkUploadPanel
          entityLabel="banner"
          templateNote={
            <>
              One row per banner, in the same order as the banner editor. Add
              translations in the <b>Title [iso]</b> and <b>Body [iso]</b>{" "}
              columns. Reference an image by its <b>Image ID</b> from the Image
              Repository. Start and End dates are in <b>UTC</b>: the banner
              turns on at the start, off at the end, and is archived after the{" "}
              <b>Content Auto-Archive Time</b> from Configurations (24 hours by
              default). Dates use the format <b>YYYY-MM-DDTHH:mm:ss</b>.
            </>
          }
          onDownloadTemplate={downloadBannerBulkTemplate}
          onValidate={validateBannerBulkUpload}
          onCommit={bulkCreateBanners}
          onViewList={() => navigate(configData.routes.homeBanners.homeBanners)}
        />
      </Box>
    </ContentShell>
  );
};

export default BulkUploadBanners;
